export const isUrlRelative = (url: string) => {
  // URL must start with /
  return url && url.match(/^\/[^/\\]/);
};
